/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useRef } from "react";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import Switch from "components/Switch";
import ColourPicker from "@visiblethread/react-components/dist/components/ColourPicker";
import {
  getWorkspaceBannerProperties,
  setWorkspaceBannerProperties,
} from "slices/systemAdmin/actions/systemAdmin";
import { htmlDecode } from "utils";

const BannerModal = ({ workspaceId }) => {
  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState("");
  const [background, setBackground] = useState("#434159");
  const [colour, setColour] = useState("#FFFFFF");
  const dispatch = useDispatch();

  const handleSave = () => {
    dispatch(
      setWorkspaceBannerProperties(workspaceId, {
        enabled,
        message,
        background,
        colour,
      })
    );
    dispatch(hideModal(modalTypes.WORKSPACE_BANNER));
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.WORKSPACE_BANNER));
  };

  const handleSwitchChange = () => {
    setEnabled(!enabled);
  };

  useEffect(() => {
    dispatch(getWorkspaceBannerProperties(workspaceId, dispatch)).then(
      (bannerProperties) => {
        setEnabled(bannerProperties.enabled);
        setMessage(htmlDecode(bannerProperties.message));
        setBackground(bannerProperties.background);
        setColour(bannerProperties.colour);
      }
    );
  }, [dispatch]);

  const switchRef = useRef(null);

  return (
    <Modal
      data-test="addUserModal"
      className="banner_popup fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <b>Set Banner</b>
      </Modal.Header>
      <Modal.Body>
        <div className="banner_popup__container">
          <span className="banner_popup__container__field">
            <label htmlFor="enable_radio_switch" className="enabled">
              Turn Banner On/Off
            </label>
            <Switch
              id="enable_radio_switch"
              switchRef={switchRef}
              handleChange={handleSwitchChange}
              currentSwitchState={enabled}
            />
          </span>
          <span className="banner_popup__container__field full_width">
            <label
              htmlFor="banner_popup__container__message_field"
              className={`message ${!enabled ? "disabled" : ""}`}
            >
              Banner Message
            </label>
            <input
              id="banner_popup__container__message_field"
              type="text"
              className={`${!enabled ? "disabled" : ""}`}
              placeholder=""
              disabled={!enabled}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </span>
          <span className="banner_popup__container__field">
            <label
              htmlFor="background-colour-button"
              className={`control_label ${!enabled ? "disabled" : ""}`}
            >
              Choose Banner Background Color
            </label>
            <ColourPicker
              disabled={!enabled}
              selectedColour={background}
              setSelectedColour={setBackground}
            />
          </span>
          <span className="banner_popup__container__field">
            <label
              htmlFor="foreground-colour-button"
              className={`control_label ${!enabled ? "disabled" : ""}`}
            >
              Choose Banner Text Color
            </label>
            <ColourPicker
              disabled={!enabled}
              selectedColour={colour}
              setSelectedColour={setColour}
            />
          </span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          dataTestId="saveButton"
          variant={buttonVariants.primary}
          onClick={handleSave}
          disabled={message === ""}
          content="Save"
        />
        <Button
          dataTestId="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default BannerModal;

BannerModal.propTypes = {
  workspaceId: PropTypes.number,
};
